'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UIMultiLevelDropdown from 'UIComponents/dropdown/UIMultiLevelDropdown';
import UsageTracker from '../../utils/UsageTracker';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import CopyToClipboardButton from 'LearningCenterUI/features/share/components/CopyToClipboardButton';
import { buildReferralLink } from '../../utils/RoutingUtils';
import { useLocation } from 'react-router-dom';
import { parse } from 'hub-http/helpers/params';
import { usePlaylist } from '../../features/savedItems';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import I18n from 'I18n';

const ShareButtonDropdown = ({
  contentId,
  contentLanguage,
  lessonId,
  lessonName,
  mobileButtons,
  trackId,
  trackName,
  userId,
  onClick
}) => {
  const trackShareButtonClick = () => {
    UsageTracker.track('interaction', {
      action: 'share-button-clicked',
      contentLanguage,
      contentId,
      lessonId,
      trackId
    });
  };

  const options = [];
  const location = useLocation();
  const {
    search
  } = location;
  const params = parse(search.slice(1));
  const playlistId = params.playlistId;
  const {
    playlist
  } = usePlaylist(playlistId, !playlistId);

  const showNotification = () => {
    FloatingAlertStore.addAlert({
      type: 'success',
      message: I18n.text('learningCenter.shareThis.notification')
    });
  };

  if (playlist) {
    options.push( /*#__PURE__*/_jsx(CopyToClipboardButton, {
      description: playlist.name,
      onClick: () => {
        if (onClick) onClick(playlistId, 'PLAYLIST');
        showNotification();
      },
      shareUrl: buildReferralLink(`saved-items/playlists/${playlistId}`, Number(userId)),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.playlists.playlist"
      }),
      trackerExtras: {
        contentLanguage,
        contentType: 'PLAYLIST',
        playlistId
      }
    }, "playlist"));
  }

  if (trackId) {
    options.push( /*#__PURE__*/_jsx(CopyToClipboardButton, {
      description: trackName,
      onClick: () => {
        if (onClick) onClick(trackId, 'TRACK');
        showNotification();
      },
      shareUrl: buildReferralLink(`course-overview/${trackId}`, Number(userId)),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.resources.type.TRACK`
      }),
      trackerExtras: {
        contentLanguage,
        contentType: 'TRACK',
        trackId
      }
    }, 'track'));
  }

  if (Number(lessonId)) {
    options.push( /*#__PURE__*/_jsx(CopyToClipboardButton, {
      description: lessonName,
      onClick: () => {
        if (onClick) onClick(trackId, 'LESSON');
        showNotification();
      },
      shareUrl: buildReferralLink(`lesson-overview/${lessonId}`, Number(userId)),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.shareThis.currentLesson"
      }),
      trackerExtras: {
        contentLanguage,
        contentType: 'LESSON',
        trackId,
        lessonId,
        contentId
      }
    }, 'lesson'));
  }

  if (mobileButtons) {
    return options;
  }

  return /*#__PURE__*/_jsx(UIMultiLevelDropdown, {
    arrowSize: "medium",
    buttonSize: "sm",
    buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.shareThis.button"
    }),
    buttonUse: "tertiary",
    caretRenderer: null,
    closeOnMenuClick: false,
    onOpenStart: trackShareButtonClick,
    options: options,
    placement: "bottom left"
  });
};

ShareButtonDropdown.propTypes = {
  contentId: PropTypes.string,
  contentLanguage: PropTypes.string,
  contentName: PropTypes.string,
  lessonId: PropTypes.string,
  lessonName: PropTypes.string,
  mobileButtons: PropTypes.bool,
  onClick: PropTypes.func,
  portalId: PropTypes.number.isRequired,
  trackId: PropTypes.string,
  trackName: PropTypes.string,
  userId: PropTypes.number.isRequired
};
export default ShareButtonDropdown;